<template>
    <div class = "main align-center">
        <div class="block">
            <textarea v-model="note" @input="updateNote" class="textarea block" placeholder="Post update about beneficiary"></textarea>
            <button @click="submitNote" :disabled="!note.trim() || isLoading" :class="[isLoading ? 'is-loading' : '']" class="button is-rounded is-info">Save</button>
        </div>
        <div v-if="getBeneficiaryHistory">
            <div v-for="history in getBeneficiaryHistory" :key="history.id" class="card">
                <div class="card-content">
                    <pre v-if="history.type=='admin_note'" class="note">{{ history.note }}</pre>
                    <table v-else-if="history.type=='audit_log'" class="table">
                        <tbody>
                            <tr>
                                <th>
                                    Field
                                </th>
                                <th>
                                    Old Value  
                                </th>
                                <th>
                                    New Value
                                </th>
                            </tr>
                            <tr v-for="(change, key) in history.changes" :key="key">
                                <td>
                                    <p>{{ key }}</p>
                                </td>
                                <td>
                                    {{ change.oldValue }}
                                </td>
                                <td>
                                    {{ change.newValue }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="footer-card">
                        <span class="author">{{ history.author }}</span>
                        <span class="timestamp">{{ history.timestamp?.toDate()?.toLocaleString() }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!!error" class="notification is-danger">
            <p>{{ error }}</p>
        </div>
    </div>
    
</template>

<script>
export default {
    props: [
        'id'
    ],
    data() {
        return {
            isLoading: false,
            error: null,
            note: ""
        }
    },
    created() {
        this.loadHistory();
    },
    computed: {
        getBeneficiaryHistory() {
            return this.$store.getters['beneficiary/getBeneficiaryHistory'];
        },
        currentUser() {
            return this.$store.getters['user/getCurrentUser'];
        }
    },
    methods: {
        async submitNote() {
            this.isLoading = true;

            try {
                await this.$store.dispatch('beneficiary/createBeneficiaryHistory', {
                    id: this.id,
                    note: this.note,
                    type: "admin_note",
                    author: this.currentUser.name,
                    changes: null
                });
                this.note = ""; // Clear textarea after submission
            } catch (error) {
                this.error = error.message;
            } finally {
                this.isLoading = false;
            }
        },
        async loadHistory() {
            this.$store.dispatch('beneficiary/listenToHistory', this.id);
        },
        updateNote(event) {
            this.note = event.target.value;
        }
    }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;  /* Space between the cards */
  background-color: #BBDDFA;
}
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5em;
  overflow-x: auto; /* Enables horizontal scrolling */
  max-width: 100%; /* Ensures it fits within the parent */
}

.content {
  display: flex;
  flex-direction: column;
}

.note {
  text-align: left;
}

.footer-card {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  margin-top: 10px;
}

.author {
  text-align: left;
}

.timestamp {
  text-align: right;
}

table {
  width: 100%;  /* Make it responsive within the parent */
  max-width: 100%; /* Prevent it from exceeding the parent width */
  table-layout: fixed; /* Allows columns to adjust automatically */
  font-size: 12px; /* Reduce text size */
  text-align: left;
}

.table:not(:last-child), .tabs:not(:last-child), .title:not(:last-child) {
    margin-bottom: 0rem;
}

table th, td {
    padding: 4px 8px; /* Reduce spacing */
    background-color: #f8f8f8; /* Optional: Light background for better visibility */
}

pre {
  all: unset;  /* Resets all inherited and default styles */
  font-family: monospace;  /* Ensures a basic monospace font */
  font-size: 12px;  /* Makes the text small */
  white-space: pre-wrap; /* Keeps formatting but allows wrapping */
  background: aliceblue; /* Removes any background color */
  padding: 5px; /* Removes extra padding */
  margin: 0; /* Removes extra margins */
  border: 1px solid #ccc; /* Adds a light gray border */
  border-radius: 8px; /* Rounds the corners */
  padding: 10px; /* Adds some space inside */
  background-color: #f8f8f8; /* Optional: Light background for better visibility */
  white-space: pre-wrap; /* Allows wrapping */
}

</style>